<template>
  <div>
    <p v-if="hasErrors" class="text-danger font-larger font-weight-bold">
      {{ document.data.veryImportantErrors }}
    </p>

    <w-input :model="schema.epuapAddress" />

    <w-input :model="schema.epuapAddressConfirm" />

    <p class="mt-3">
      Uwaga. Jak znaleźć swój adres elektroniczny ePUAP?
    </p>

    <p>
      Adres elektroniczny znajdziesz na swoim koncie ePUAP. Wejdź na stronę epuap.gov.pl i zaloguj się. Wybierz: Moja
      skrzynka → Operacje → informacje szczegółowe skrzynki (znak plusa) > adres znajduje się w polu lista adresów
      skrytek dla danej skrzynki w formacie /login/nazwaskrzynki.
    </p>

    <reply-form-select :schema="schema" />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import { formMixin } from '@/mixins/form';

import ReplyFormSelect from './ReplyFormSelect.vue';

// @vuese
// Modal podpisywania  dokumentu podpisem kwalifikowanym
// @group ActionData
export default {
  components: { ReplyFormSelect },
  mixins: [formMixin],
  props: {
    // schema akcji
    schema: { type: Object, required: true }
  },
  computed: {
    ...mapState({
      document: state => state.document.data
    }),

    hasErrors() {
      return (
        this.document.data &&
        this.document.data.veryImportantErrors &&
        this.document.data.veryImportantErrors !== 'false'
      );
    }
  }
};
</script>
